module.exports = __webpack_public_path__ + "static/media/check-icon.d2386ed4.png";